import React from 'react';


export class quienes_somos extends React.Component {
	render(){
		return (
			<div id="quienes_somos">
		
				<section class="container-fluid quienes-somos-container">
						<article class="row justify-content-md-center">
							<div class="col-12">
								<div class="bg-box-form">
									<img src="/imga/bg_bulonera.jpg"/>
									<h2>Quienes somos</h2>
									<p>Somos una empresa dedicada a la producción y comercialización de
									artículos de bulonería y afines en un mercado que abarca todo el país.Más de
									55 años de trayectoria y una importante cartera de clientes avalan el
									compromiso que poseemos con la calidad y el servicio.</p>
									<p>Nuestra línea de productos es muy extensa y variada. Disponemos de
									más de 20.000 artículos que se traduce en un amplio stock de 800 toneladas
									de material ya elaborado, listo para su comercialización. De esta forma nos
									encontramos en condiciones de satisfacer al instante las necesidades de
									nuestros clientes.</p>
									<p>Conjuntamente elaboramos piezas estampadas o torneadas bajo plano
									de aceros SAE 1010 - 1020 - 1038 - 1045 - 4140 - 8640, acero inoxidable,
									latón, cobre y aleaciones especiales. Toda esta producción se confecciona
									utilizando materiales rigurosamente controlados antes de su fabricación 
									y luego de los tratamientos finales previos a la entrega al cliente.</p>
									<p>Telefonos: (011) 4207-2880/7719/6914 Whatsapp: (011) 2526-7412</p>
									<p>Email: elemporiodelbulon@gmail.com</p>
								</div>
								
							</div>
						</article>
						
					</section>
			</div>
		);
	}
} 


// WEBPACK FOOTER //
// ./src/components/quienes_somos.js